<script>
  import ActionReportMixin from './ActionReportMixin.vue'

  export default {
    name: 'rbv-hotel-rfp-bid-manager-delete-bids-action-report',
    mixins: [ ActionReportMixin ],
    data () {
      return {
        messages: {
          'OK': 'Deleted',
          'NOT_FOUND': 'Delete Failed - Bid not found',
          'STATUS_CHANGED': 'Delete Failed - Bid Changed',
          'ERROR': 'Delete Failed'
        }
      }
    },
    computed: {
      title () { return this.items.length === 1 ? "Delete failed!" : "Some bids could not be deleted!" },
      message () {
        return this.items.length === 1
          ? "We were not able to delete a bid because of the reason listed below:"
          : `${this.items.length - this.failures} of ${this.items.length} bids were successfully deleted.<br /> We were not able to delete all bids because of the reasons listed below:`
      }
    }
  }
</script>
